export enum SERVER {
  Hybris,
  IDP,
  Local,
  Mashery,
  Public,
  Open
}
